'use client';

import { c as _c } from "react/compiler-runtime";
import { Size } from '@sprd/sprd-component-kit/v2';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
const SIZE_FIT_HINT_KEYS = {
  '1': 'runsSmall',
  '2': 'trueToSize',
  '3': 'runsLarge'
} as const;
export const SizeFitHint = t0 => {
  const $ = _c(11);
  const {
    className,
    sizeFitHintId
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== className) {
    t1 = clsx("flex items-start gap-1.5", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="flex h-[1lh] shrink-0 items-center"><Size aria-hidden={true} className="size-5" /></span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== sizeFitHintId || $[4] !== t) {
    t3 = t.rich(`size.fitHint.${SIZE_FIT_HINT_KEYS[sizeFitHintId]}`, {
      bold: _temp
    });
    $[3] = sizeFitHintId;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <span>{t3}</span>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t4) {
    t5 = <p className={t1}>{t2}{t4}</p>;
    $[8] = t1;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
function _temp(chunks) {
  return <span className="font-semibold">{chunks}</span>;
}